import React from 'react';
import Box from '../../Box/Box.js';
import { defaultSxProp } from '../../utils/defaultSxProp.js';
import { includesSystemProps } from '../../utils/includeSystemProps.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const BoxWithFallback = /*#__PURE__*/React.forwardRef(function BoxWithFallback({
  as: BaseComponent = 'div',
  sx = defaultSxProp,
  ...rest
}, ref) {
  if (sx !== defaultSxProp || includesSystemProps(rest)) {
    return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
      ref: ref,
      as: BaseComponent,
      sx: sx
    }));
  }
  return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, rest, {
    ref: ref
  }));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
});

export { BoxWithFallback };
